import { getParentEdgeTypeId } from '@iotv/datamodel';
import { BranchingQueryDefinition, NodeEdgeMapper, getItemTypeToGroupNestedAscendingQueryDef, getItemTypeToGroupNestedDescendingQueryDef, getClosestItemTypeToGroupNestedAscendingQueryDef, getSimpleBranchingQuery, getSpecificEdgeTypeId, } from '@iotv/datamodel-core';
import { AdjacentType } from '@iotv/iotv-v3-types';
import { deviceEnabledTypes } from '@iotv/payload-definition';
import { getParents } from '../..//data/daoFunctions/daoFunctions';
import ApiGateway from '../../data/aws/api-gateway/ApiGateway';
import { getGraphQueryRequestV2 } from '../daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
const debug = process.env.REACT_APP_DEBUG && false;
/** Returns all group and allows_group edges,  from users directly related customers */
export const systemManagmentUserCustomersQuery = async function (user) {
    let queryData = new NodeEdgeMapper();
    if (user) {
        const query = new BranchingQueryDefinition({
            path: [
                /** this should be changed to use user groups hierarchy (getNestedStructureBranchingQuery) */
                { objectTypeId: 'Customer', adjacencyType: AdjacentType.PARENT, edgeTypeId: getParentEdgeTypeId('User', 'Customer') },
            ],
            id: 'systemManagmentUserCustomersQuery_UserToCustomers',
            subQueries: [
                // getItemTypeToGroupNestedDescendingQueryDef( { groupDefiningObjectTypeId: 'Customer', supportedType: 'Customer', includeSupportedTypeInstances: true,  addIdPrefixes: true  }),
                getItemTypeToGroupNestedDescendingQueryDef({
                    groupDefiningObjectTypeId: 'Customer',
                    supportedType: 'User',
                    includeSupportedTypeInstances: true,
                    addIdPrefixes: true,
                }),
                getItemTypeToGroupNestedDescendingQueryDef({
                    groupDefiningObjectTypeId: 'Customer',
                    supportedType: 'Device',
                    includeSupportedTypeInstances: false,
                    addIdPrefixes: true,
                }),
                getItemTypeToGroupNestedDescendingQueryDef({
                    groupDefiningObjectTypeId: 'Customer',
                    supportedType: 'Gateway',
                    includeSupportedTypeInstances: false,
                    addIdPrefixes: true,
                }),
                ...Object.keys(deviceEnabledTypes).map((type) => getItemTypeToGroupNestedDescendingQueryDef({
                    groupDefiningObjectTypeId: 'Customer',
                    supportedType: type,
                    includeSupportedTypeInstances: false,
                    addIdPrefixes: true,
                })),
            ],
        });
        const queryDataRes = await getGraphQueryRequestV2({
            contextObjects: [user],
            query,
        });
        if (queryDataRes.data) {
            queryData = queryDataRes.data;
            debug && console.log(`systemManagmentUserCustomersQuery returned`, queryData);
        }
        else {
            console.log(`Err in get customers`, queryDataRes.err?.message);
        }
    }
    return queryData;
};
/** Returns allowed user, device, gateway, and entity groups based on the customer that owns the group that owns the user */
export const userToAllGroupsQuery = async function (user) {
    let queryData = new NodeEdgeMapper();
    if (user) {
        /** Traverses user -> user group -> ... -> user group -> Customer */
        /** Stops at nearest customer, we don't want to go too far */
        /** Doesn't go lower than groups for current customer for fear of loading entire app into appstate, but might want to do that. */
        const upToCustomerQuery = getClosestItemTypeToGroupNestedAscendingQueryDef({
            groupDefiningObjectTypeId: 'Customer',
            sourceItemType: 'User',
            finalSubQueries: [
                ...Object.keys(deviceEnabledTypes).map((type) => getItemTypeToGroupNestedDescendingQueryDef({
                    groupDefiningObjectTypeId: 'Customer',
                    supportedType: type,
                    includeSupportedTypeInstances: false,
                    addIdPrefixes: true,
                })),
            ],
        });
        try {
            const queryDataRes = await getGraphQueryRequestV2({
                contextObjects: [user],
                query: upToCustomerQuery,
            });
            if (queryDataRes.data) {
                queryData = queryDataRes.data;
                debug && console.log(`userToAllGroupsQuery returned`, queryData);
            }
            else {
                console.log(`Err in userToAllGroupsQuery`, queryDataRes.err?.message);
            }
        }
        catch (e) {
            console.log(`ERR: Caught Err in userToAllGroupsQuery`, e?.message);
        }
    }
    return queryData;
};
/** Gets the user group from a user then finds all groups shared with that user group. WARN: does not check if visible group is in current context customer */
export const userToVisibleGroupsQuery = async (user) => {
    let queryData = new NodeEdgeMapper();
    const userToGroupQuery = getSimpleBranchingQuery('User', 'Group', AdjacentType.PARENT);
    userToGroupQuery.addSubQuery(new BranchingQueryDefinition({
        id: 'userToVisibleGroups',
        path: [
            {
                objectTypeId: 'Group',
                edgeTypeId: getSpecificEdgeTypeId('Group', 'Group', 'group_allows_group'),
            },
        ],
        subQueries: [],
    }));
    try {
        const queryDataRes = await getGraphQueryRequestV2({
            contextObjects: [user],
            query: userToGroupQuery,
        });
        if (queryDataRes.data) {
            queryData = queryDataRes.data;
            debug && console.log(`userToVisibleGroupsQuery returned`, queryData);
        }
        else {
            console.log(`Err in userToVisibleGroupsQuery`, queryDataRes.err?.message);
        }
    }
    catch (e) {
        console.log(`ERR: Caught Err in userToVisibleGroupsQuery`, e?.message);
    }
    return queryData;
};
/** Returns all group and allows_group edges, currently from apex customer */
export const apexCustomerUserCustomersQuery = async function (user) {
    let queryData = new NodeEdgeMapper();
    if (user) {
        const subQueries = [
            getItemTypeToGroupNestedDescendingQueryDef({
                groupDefiningObjectTypeId: 'Customer',
                supportedType: 'Customer',
                includeSupportedTypeInstances: true,
                addIdPrefixes: true,
            }),
            // getItemTypeToGroupNestedDescendingQueryDef( { groupDefiningObjectTypeId: 'Customer', supportedType: 'User', includeSupportedTypeInstances: true, addIdPrefixes: true  }),
            // getItemTypeToGroupNestedDescendingQueryDef( { groupDefiningObjectTypeId: 'Customer', supportedType: 'Device', includeSupportedTypeInstances: false, addIdPrefixes: true  }),
            // getItemTypeToGroupNestedDescendingQueryDef( { groupDefiningObjectTypeId: 'Customer', supportedType: 'Gateway', includeSupportedTypeInstances: false, addIdPrefixes: true  }),
            // ...Object.keys(deviceEnabledTypes).map( ( type ) =>  getItemTypeToGroupNestedDescendingQueryDef( { groupDefiningObjectTypeId: 'Customer', supportedType: type, includeSupportedTypeInstances: false, addIdPrefixes: true  }),)
        ];
        const query = getItemTypeToGroupNestedAscendingQueryDef({
            groupDefiningObjectTypeId: 'Customer',
            sourceItemType: 'User',
            addIdPrefixes: true,
            finalSubQueries: subQueries,
        });
        debug && console.log(`SUMMARIZED apexCustomerUserCustomersQuery: `, query.summarize());
        const queryDataRes = await getGraphQueryRequestV2({
            contextObjects: [user],
            query,
        });
        if (queryDataRes.data) {
            queryData = queryDataRes.data;
            debug && console.log(`apexCustomerUserCustomersQuery returned`, queryData);
        }
        else {
            console.log(`Err in get customers`, queryDataRes.err?.message);
        }
    }
    return queryData;
};
/**
 * Fetches the communities related to the customer object
 * @param contextCustomer ValidBusinessObject for the current customer
 * @returns
 */
export const getCustomerHierarchy = async (contextCustomer) => {
    let res = { err: null, data: null };
    if (contextCustomer) {
        const queryBody = {
            apexNode: contextCustomer,
            edgeParams: {
                objectTypeId: 'Customer',
            },
            maxIterations: 10,
        };
        const path = '/typeHierarchy/';
        res = await ApiGateway.post(path, queryBody);
    }
    return res;
};
/**
 * @function userDirectCustomersQuery gets users directly connected customers. This was the original query to get contextCustomers
 * @param user

 * @returns
 */
export const userDirectCustomersQuery = async function (user) {
    const queryData = new NodeEdgeMapper();
    const customersRes = await getParents(user, 'Customer');
    debug && console.log('CUSTOMERS', customersRes);
    if (customersRes.data?.Items) {
        queryData.loadItems(customersRes.data.Items);
        debug && console.log('CUSTOMERS nodeEdgeMapper', queryData);
    }
    return queryData;
};
